var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailCloseLine = function SvgMailCloseLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 13.8h-1.8V7.715l-7.135 6.39L4.8 7.695V18.3h9.9v1.8H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9zM5.26 5.7l6.795 5.996L18.752 5.7zm15.213 12.6 1.91 1.91-1.274 1.273-1.909-1.91-1.909 1.91-1.273-1.274 1.91-1.909-1.91-1.909 1.273-1.273 1.909 1.91 1.909-1.91 1.273 1.274-1.91 1.908Z"
  })));
};
export default SvgMailCloseLine;